export const LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "zh", label: "中文" },
];

export const T = {
  en: {
    nav: { home: "Home", products: "Products", services: "Services", about: "About", contact: "Contact", quote: "Request a Quote", callNow: "Call Now" },
    topbarHours: "Mon – Fri: 6:00 AM – 8:00 PM",
    home: {
      heroOverline: "San Bernardino, CA — Inland Empire",
      heroTitle: "All Your Pallet Needs Covered",
      heroSub: "New, used, custom, and heat-treated pallets for businesses across the Inland Empire.",
      stats: ["New & Used Options", "Pickup & Local Delivery", "Fast Local Response"],
      servicesOverline: "What We Do",
      servicesTitle: "Reliable Pallet Solutions for Local Businesses",
      servicesText: "Pallet Works Logistic provides dependable pallet solutions for warehouses, manufacturers, distributors, and shipping operations across the Inland Empire.",
      requestQuote: "Request Quote",
      whyOverline: "Why Us",
      whyTitle: "Why Choose Pallet Works Logistic?",
      whyPoints: [
        "Reliable local pallet supplier",
        "New and used pallet options",
        "Custom pallet solutions",
        "Pickup and local delivery available",
        "Pallet recycling services",
        "Fast response for local businesses",
      ],
      whyBadgeTop: "Local & Dependable",
      areaOverline: "Service Area",
      areaTitle: "Serving the Inland Empire",
      areaText: "We proudly serve San Bernardino, Fontana, Ontario, Chino, Rialto, Rancho Cucamonga, and nearby Inland Empire businesses.",
      areaMore: "+ nearby areas",
    },
    cta: {
      overline: "Get Started Today",
      title: "Need Reliable Pallets for Your Business?",
      text: "Contact Pallet Works Logistic today to request pricing, availability, pickup, or local delivery.",
    },
    servicesPage: {
      overline: "Our Services",
      title: "Pallet Services",
      intro: "Pallet Works Logistic helps businesses with practical pallet solutions for shipping, storage, warehouse operations, recycling, and local delivery.",
    },
    productsPage: {
      overline: "Our Products",
      title: "Pallet Products",
      intro: "We supply different pallet options depending on your business needs, availability, quantity, and handling requirements.",
    },
    about: {
      overline: "Who We Are",
      title: "About Pallet Works Logistic",
      intro: "Dependable pallet solutions from a local San Bernardino team.",
      storyOverline: "Our Story",
      storyTitle: "Practical Pallet Solutions, Local Service",
      storyText: "Pallet Works Logistic provides reliable pallet solutions for warehouses, manufacturers, distributors, and local businesses across the Inland Empire. We focus on dependable service, practical pallet options, and fast communication for businesses that need pallets for daily operations.",
      focusOverline: "What We Focus On",
      focusTitle: "Built Around Your Operation",
      focuses: [
        { title: "Local Business Focus", desc: "Based in San Bernardino and built around the needs of Inland Empire businesses." },
        { title: "Warehouse & Shipping Support", desc: "Pallet supply that keeps your docks, racks, and outbound freight moving." },
        { title: "Pickup & Delivery Available", desc: "We come to you — pallet pickup and local delivery across the region." },
        { title: "Recycling & Supply Options", desc: "New, used, and recycled pallet options that fit your budget and volume." },
      ],
    },
    contact: {
      overline: "Get In Touch",
      title: "Request a Pallet Quote",
      intro: "Tell us what you need and we'll respond with pricing and availability.",
      formTitle: "Request a Quote",
      formSub: "Fill out the form below and our team will get back to you fast.",
      success: "Thanks — your quote request has been received. For urgent needs, call us at",
      fields: {
        name: "Name *",
        company: "Company Name",
        phone: "Phone Number *",
        email: "Email Address *",
        service: "Pallet Type / Service Needed *",
        quantity: "Quantity Needed",
        fulfillment: "Pickup or Delivery *",
        message: "Message",
      },
      placeholders: {
        name: "Your name",
        company: "Your company",
        phone: "(909) 555-0123",
        email: "you@company.com",
        quantity: "e.g. 100",
        message: "Tell us about sizes, timeline, or anything else we should know.",
        selectService: "Select a pallet type or service",
        selectFulfillment: "Select an option",
      },
      pickup: "Pickup",
      delivery: "Delivery",
      other: "Other",
      submit: "Send Quote Request",
      sending: "Sending...",
      toastSuccess: "Quote request sent. We'll get back to you shortly.",
      toastError: "Something went wrong. Please call us at (909) 955-7500.",
      hoursLabel: "Hours",
    },
    hours: [
      { days: "Monday – Friday", time: "6:00 AM – 8:00 PM" },
      { days: "Saturday", time: "By appointment" },
      { days: "Sunday", time: "Closed" },
    ],
    services: {
      "new-pallets": {
        title: "New Pallets",
        short: "Freshly built wood pallets constructed to your size, spec, and load requirements.",
        long: "New wood pallets built from quality lumber and assembled to handle your day-to-day shipping, storage, and warehouse operations. Standard sizes like 48x40 GMA or built to your exact specification.",
      },
      "used-pallets": {
        title: "Used Pallets",
        short: "Inspected, graded used pallets — a cost-effective option for everyday shipping.",
        long: "Quality used pallets that are inspected, repaired, and graded before resale. A practical, budget-friendly option for one-way shipping, storage, and general warehouse use.",
      },
      "custom-pallets": {
        title: "Custom Pallets",
        short: "Built-to-order pallet sizes and designs for oversized, heavy, or unusual loads.",
        long: "When standard sizes won't work, we build custom pallets and skids to match your product dimensions, weight, and handling equipment — from oversized machinery bases to specialty skids.",
      },
      "euro-pallets": {
        title: "Euro Pallets",
        short: "Standard 1200 x 800 Euro-style block pallets for domestic and international freight.",
        long: "Euro-style block pallets in the standard 1200 x 800 mm footprint, built for four-way entry and compatible with European and international supply chains.",
      },
      "plastic-pallets": {
        title: "Plastic Pallets",
        short: "Durable, washable plastic pallets for food, pharma, and closed-loop operations.",
        long: "Heavy-duty plastic pallets that resist moisture, splinters, and contamination. Ideal for food processing, pharmaceuticals, and closed-loop distribution programs.",
      },
      "corrugated-pallets": {
        title: "Corrugated Pallets",
        short: "Lightweight, recyclable corrugated pallets for one-way shipping and air freight.",
        long: "Lightweight corrugated pallets that cut freight weight and cost. Fully recyclable and a smart choice for one-way shipments, export cartons, and air freight.",
      },
      "pallet-recycling": {
        title: "Pallet Recycling",
        short: "We pick up, repair, and recycle unwanted pallets to keep your yard clear.",
        long: "Keep your dock and yard clear. We pick up unwanted, broken, or surplus pallets, repair what can be reused, and responsibly recycle the rest.",
      },
      "pickup-delivery": {
        title: "Pallet Pickup & Delivery",
        short: "Local pickup and delivery across the Inland Empire on your schedule.",
        long: "We pick up surplus pallets and deliver orders directly to your dock across San Bernardino and the Inland Empire. Flexible scheduling for recurring or one-time needs.",
      },
      "heat-treated-pallets": {
        title: "Heat-Treated Pallets",
        short: "ISPM-15 compliant heat-treated pallets, ready for export and regulated freight.",
        long: "Heat-treated wood pallets that meet ISPM-15 export requirements. Properly treated and stamped so your international shipments clear inspection without delays.",
      },
    },
    servicesCardOverrides: {
      "used-pallets": {
        title: "Food Grade Pallets",
        long: "Clean pallet options for food-related storage, handling, and distribution needs. Available in standard pallet sizes, including 48x40, depending on availability.",
      },
      "custom-pallets": {
        title: "Grade B Pallets",
      },
      "euro-pallets": {
        title: "Regular Pallets",
      },
      "corrugated-pallets": {
        title: "Used Pallet Stacks",
      },
      "heat-treated-pallets": {
        title: "Heat-Treated Pallet Stacks",
      },
      "pallet-recycling": {
        title: "Warehouse Pallet Supply",
        long: "Pallet supply solutions for warehouses, distributors, and local businesses. We help support daily shipping, storage, and handling operations with reliable pallet options.",
      },
      "new-pallets": {
        title: "Pallet Supply & Delivery",
        long: "Reliable pallet supply and delivery for businesses that need pallets in bulk. We help support warehouse, shipping, storage, and daily operations with dependable local service.",
      },
    },
    products: {
      "new-pallets": { name: "New Pallets", desc: "Freshly built wood pallets in standard and custom sizes, ready for daily operations." },
      "used-pallets": { name: "Used Pallets", desc: "Inspected and graded used pallets — dependable quality at a lower cost." },
      "custom-pallets": { name: "Custom Pallets", desc: "Built to your dimensions, weight rating, and handling requirements." },
      "euro-pallets": { name: "Euro Pallets", desc: "1200 x 800 block-style pallets for international and domestic supply chains." },
      "plastic-pallets": { name: "Plastic Pallets", desc: "Moisture-resistant, washable pallets for sanitary and closed-loop operations." },
      "corrugated-pallets": { name: "Corrugated Pallets", desc: "Lightweight, fully recyclable pallets for one-way and air freight shipments." },
      "cp1-cp3-pallets": { name: "CP1 & CP3 Pallets", desc: "Chemical industry standard CP pallets for bagged and drummed goods." },
      "heat-treated-pallets": { name: "Heat-Treated Pallets", desc: "ISPM-15 compliant, stamped, and ready for export and regulated freight." },
    },
    footer: {
      quickLinks: "Quick Links",
      services: "Services",
      contactInfo: "Contact Info",
      description: "Reliable pallet solutions for warehouses, manufacturers, distributors, and local businesses across the Inland Empire.",
      rights: "All rights reserved.",
      location: "San Bernardino, CA — Inland Empire",
    },
  },

  es: {
    nav: { home: "Inicio", products: "Productos", services: "Servicios", about: "Nosotros", contact: "Contacto", quote: "Solicitar Cotización", callNow: "Llamar Ahora" },
    topbarHours: "Lun – Vie: 6:00 AM – 8:00 PM",
    home: {
      heroOverline: "San Bernardino, CA — Inland Empire",
      heroTitle: "Todas Sus Necesidades de Pallets en un Solo Lugar",
      heroSub: "Pallets nuevos, usados, personalizados y tratados térmicamente para negocios en el Inland Empire.",
      stats: ["Opciones Nuevas y Usadas", "Recolección y Entrega Local", "Respuesta Local Rápida"],
      servicesOverline: "Lo Que Hacemos",
      servicesTitle: "Soluciones Confiables de Pallets para Negocios Locales",
      servicesText: "Pallet Works Logistic ofrece soluciones confiables de pallets para almacenes, fabricantes, distribuidores y operaciones de envío en el Inland Empire.",
      requestQuote: "Solicitar Cotización",
      whyOverline: "Por Qué Nosotros",
      whyTitle: "¿Por Qué Elegir Pallet Works Logistic?",
      whyPoints: [
        "Proveedor local confiable de pallets",
        "Opciones de pallets nuevos y usados",
        "Soluciones de pallets personalizados",
        "Recolección y entrega local disponible",
        "Servicios de reciclaje de pallets",
        "Respuesta rápida para negocios locales",
      ],
      whyBadgeTop: "Local y Confiable",
      areaOverline: "Área de Servicio",
      areaTitle: "Sirviendo el Inland Empire",
      areaText: "Con orgullo servimos San Bernardino, Fontana, Ontario, Chino, Rialto, Rancho Cucamonga y negocios cercanos en el Inland Empire.",
      areaMore: "+ áreas cercanas",
    },
    cta: {
      overline: "Comience Hoy",
      title: "¿Necesita Pallets Confiables para su Negocio?",
      text: "Contáctenos hoy para solicitar precios, disponibilidad, recolección o entrega local.",
    },
    servicesPage: {
      overline: "Nuestros Servicios",
      title: "Servicios de Pallets",
      intro: "Pallet Works Logistic ayuda a los negocios con soluciones prácticas de pallets para envíos, almacenamiento, operaciones de almacén, reciclaje y entrega local.",
    },
    productsPage: {
      overline: "Nuestros Productos",
      title: "Productos de Pallets",
      intro: "Suministramos diferentes opciones de pallets según las necesidades de su negocio, disponibilidad, cantidad y requisitos de manejo.",
    },
    about: {
      overline: "Quiénes Somos",
      title: "Acerca de Pallet Works Logistic",
      intro: "Soluciones confiables de pallets de un equipo local en San Bernardino.",
      storyOverline: "Nuestra Historia",
      storyTitle: "Soluciones Prácticas de Pallets, Servicio Local",
      storyText: "Pallet Works Logistic ofrece soluciones confiables de pallets para almacenes, fabricantes, distribuidores y negocios locales en el Inland Empire. Nos enfocamos en servicio confiable, comunicación rápida y opciones prácticas para empresas que necesitan pallets para sus operaciones diarias.",
      focusOverline: "En Qué Nos Enfocamos",
      focusTitle: "Diseñado para su Operación",
      focuses: [
        { title: "Enfoque en Negocios Locales", desc: "Con base en San Bernardino y dedicados a las necesidades de los negocios del Inland Empire." },
        { title: "Soporte de Almacén y Envíos", desc: "Suministro de pallets que mantiene sus andenes, estanterías y cargas en movimiento." },
        { title: "Recolección y Entrega Disponible", desc: "Vamos a usted — recolección de pallets y entrega local en toda la región." },
        { title: "Opciones de Reciclaje y Suministro", desc: "Opciones de pallets nuevos, usados y reciclados que se ajustan a su presupuesto y volumen." },
      ],
    },
    contact: {
      overline: "Contáctenos",
      title: "Solicitar una Cotización de Pallets",
      intro: "Cuéntenos qué necesita y le responderemos con precios y disponibilidad.",
      formTitle: "Solicitar Cotización",
      formSub: "Complete el formulario y nuestro equipo le responderá rápidamente.",
      success: "Gracias — su solicitud de cotización ha sido recibida. Para necesidades urgentes, llámenos al",
      fields: {
        name: "Nombre *",
        company: "Nombre de la Compañía",
        phone: "Teléfono *",
        email: "Correo Electrónico *",
        service: "Tipo de Pallet o Servicio Necesario *",
        quantity: "Cantidad Necesaria",
        fulfillment: "Recolección o Entrega *",
        message: "Mensaje",
      },
      placeholders: {
        name: "Su nombre",
        company: "Su compañía",
        phone: "(909) 555-0123",
        email: "usted@compania.com",
        quantity: "ej. 100",
        message: "Cuéntenos sobre tamaños, tiempos de entrega o cualquier otra información importante.",
        selectService: "Seleccione un tipo de pallet o servicio",
        selectFulfillment: "Seleccione una opción",
      },
      pickup: "Recolección",
      delivery: "Entrega",
      other: "Otro",
      submit: "Enviar Solicitud de Cotización",
      sending: "Enviando...",
      toastSuccess: "Solicitud enviada. Le responderemos pronto.",
      toastError: "Algo salió mal. Llámenos al (909) 955-7500.",
      hoursLabel: "Horario",
    },
    hours: [
      { days: "Lunes – Viernes", time: "6:00 AM – 8:00 PM" },
      { days: "Sábado", time: "Con cita" },
      { days: "Domingo", time: "Cerrado" },
    ],
    services: {
      "new-pallets": {
        title: "Pallets Nuevos",
        short: "Pallets de madera recién construidos según su tamaño, especificación y requisitos de carga.",
        long: "Pallets de madera nuevos construidos con madera de calidad para manejar sus operaciones diarias de envío, almacenamiento y almacén. Tamaños estándar como 48x40 GMA o construidos a su especificación exacta.",
      },
      "used-pallets": {
        title: "Pallets Usados",
        short: "Pallets usados inspeccionados y clasificados — una opción económica para envíos diarios.",
        long: "Pallets usados de calidad que son inspeccionados, reparados y clasificados antes de la reventa. Una opción práctica y económica para envíos de una vía, almacenamiento y uso general de almacén.",
      },
      "custom-pallets": {
        title: "Pallets Personalizados",
        short: "Tamaños y diseños de pallets hechos a pedido para cargas grandes, pesadas o inusuales.",
        long: "Cuando los tamaños estándar no funcionan, construimos pallets y plataformas personalizadas según las dimensiones, el peso y el equipo de manejo de su producto.",
      },
      "euro-pallets": {
        title: "Pallets Euro",
        short: "Pallets de bloque estilo Euro estándar de 1200 x 800 para carga nacional e internacional.",
        long: "Pallets de bloque estilo Euro en el tamaño estándar de 1200 x 800 mm, construidos para entrada de cuatro vías y compatibles con cadenas de suministro europeas e internacionales.",
      },
      "plastic-pallets": {
        title: "Pallets de Plástico",
        short: "Pallets de plástico duraderos y lavables para operaciones de alimentos, farmacéutica y circuito cerrado.",
        long: "Pallets de plástico resistentes que resisten la humedad, las astillas y la contaminación. Ideales para procesamiento de alimentos, productos farmacéuticos y programas de distribución de circuito cerrado.",
      },
      "corrugated-pallets": {
        title: "Pallets Corrugados",
        short: "Pallets corrugados ligeros y reciclables para envíos de una vía y carga aérea.",
        long: "Pallets corrugados ligeros que reducen el peso y el costo del flete. Totalmente reciclables y una opción inteligente para envíos de una vía, cajas de exportación y carga aérea.",
      },
      "pallet-recycling": {
        title: "Reciclaje de Pallets",
        short: "Recolectamos, reparamos y reciclamos pallets no deseados para mantener su patio despejado.",
        long: "Mantenga su andén y patio despejados. Recolectamos pallets no deseados, rotos o excedentes, reparamos los que pueden reutilizarse y reciclamos responsablemente el resto.",
      },
      "pickup-delivery": {
        title: "Recolección y Entrega de Pallets",
        short: "Recolección y entrega local en todo el Inland Empire según su horario.",
        long: "Recolectamos pallets excedentes y entregamos pedidos directamente a su andén en San Bernardino y el Inland Empire. Horarios flexibles para necesidades recurrentes o únicas.",
      },
      "heat-treated-pallets": {
        title: "Pallets Tratados Térmicamente",
        short: "Pallets tratados térmicamente conformes a ISPM-15, listos para exportación y carga regulada.",
        long: "Pallets de madera tratados térmicamente que cumplen con los requisitos de exportación ISPM-15. Tratados y sellados correctamente para que sus envíos internacionales pasen la inspección sin demoras.",
      },
    },
    servicesCardOverrides: {
      "used-pallets": {
        title: "Pallets de Grado Alimenticio",
        long: "Opciones de pallets limpios para almacenamiento, manejo y distribución de productos alimenticios. Disponibles en tamaños estándar, incluyendo 48x40, según disponibilidad.",
      },
      "custom-pallets": {
        title: "Pallets Grado B",
      },
      "euro-pallets": {
        title: "Pallets Regulares",
      },
      "corrugated-pallets": {
        title: "Pilas de Pallets Usados",
      },
      "heat-treated-pallets": {
        title: "Pilas de Pallets Tratados Térmicamente",
      },
      "pallet-recycling": {
        title: "Suministro de Pallets para Almacenes",
        long: "Soluciones de suministro de pallets para almacenes, distribuidores y negocios locales. Ayudamos a apoyar las operaciones diarias de envío, almacenamiento y manejo con opciones confiables de pallets.",
      },
      "new-pallets": {
        title: "Suministro y Entrega de Pallets",
        long: "Suministro y entrega confiable de pallets para negocios que necesitan pallets en volumen. Apoyamos operaciones de almacén, envío, almacenamiento y operaciones diarias con un servicio local confiable.",
      },
    },
    products: {
      "new-pallets": { name: "Pallets Nuevos", desc: "Pallets de madera recién construidos en tamaños estándar y personalizados, listos para operaciones diarias." },
      "used-pallets": { name: "Pallets Usados", desc: "Pallets usados inspeccionados y clasificados — calidad confiable a menor costo." },
      "custom-pallets": { name: "Pallets Personalizados", desc: "Construidos según sus dimensiones, capacidad de peso y requisitos de manejo." },
      "euro-pallets": { name: "Pallets Euro", desc: "Pallets estilo bloque de 1200 x 800 para cadenas de suministro internacionales y nacionales." },
      "plastic-pallets": { name: "Pallets de Plástico", desc: "Pallets resistentes a la humedad y lavables para operaciones sanitarias y de circuito cerrado." },
      "corrugated-pallets": { name: "Pallets Corrugados", desc: "Pallets ligeros y totalmente reciclables para envíos de una vía y carga aérea." },
      "cp1-cp3-pallets": { name: "Pallets CP1 y CP3", desc: "Pallets CP estándar de la industria química para productos embolsados y en tambores." },
      "heat-treated-pallets": { name: "Pallets Tratados Térmicamente", desc: "Conformes a ISPM-15, sellados y listos para exportación y carga regulada." },
    },
    footer: {
      quickLinks: "Enlaces Rápidos",
      services: "Servicios",
      contactInfo: "Información de Contacto",
      description: "Soluciones confiables de pallets para almacenes, fabricantes, distribuidores y negocios locales en el Inland Empire.",
      rights: "Todos los derechos reservados.",
      location: "San Bernardino, CA — Inland Empire",
    },
  },

  zh: {
    nav: { home: "首页", products: "产品", services: "服务", about: "关于我们", contact: "联系", quote: "获取报价", callNow: "立即致电" },
    topbarHours: "周一至周五: 6:00 AM – 8:00 PM",
    home: {
      heroOverline: "San Bernardino, CA — Inland Empire",
      heroTitle: "满足您所有托盘需求",
      heroSub: "为 Inland Empire 地区的企业提供新托盘、二手托盘、定制托盘和热处理托盘。",
      stats: ["新旧托盘可选", "取货与本地配送", "本地快速响应"],
      servicesOverline: "我们的业务",
      servicesTitle: "为本地企业提供可靠的托盘解决方案",
      servicesText: "Pallet Works Logistic 为 Inland Empire 地区的仓库、制造商、分销商和物流运输企业提供可靠的托盘解决方案。",
      requestQuote: "获取报价",
      whyOverline: "为什么选择我们",
      whyTitle: "为什么选择 Pallet Works Logistic?",
      whyPoints: [
        "可靠的本地托盘供应商",
        "新旧托盘均可选择",
        "定制托盘解决方案",
        "提供取货和本地配送",
        "托盘回收服务",
        "本地企业快速响应",
      ],
      whyBadgeTop: "本地可靠",
      areaOverline: "服务区域",
      areaTitle: "服务 Inland Empire 地区",
      areaText: "我们自豪地为 San Bernardino、Fontana、Ontario、Chino、Rialto、Rancho Cucamonga 及 Inland Empire 周边地区的企业提供服务。",
      areaMore: "+ 周边地区",
    },
    cta: {
      overline: "立即开始",
      title: "您的企业需要可靠的托盘吗？",
      text: "立即联系我们，了解价格、库存、取货或本地配送服务。",
    },
    servicesPage: {
      overline: "我们的服务",
      title: "托盘服务",
      intro: "Pallet Works Logistic 为企业提供实用的托盘解决方案，涵盖运输、仓储、仓库运营、回收和本地配送。",
    },
    productsPage: {
      overline: "我们的产品",
      title: "托盘产品",
      intro: "我们根据您的业务需求、库存情况、数量和搬运要求提供不同的托盘选择。",
    },
    about: {
      overline: "关于我们",
      title: "关于 Pallet Works Logistic",
      intro: "来自 San Bernardino 本地团队的可靠托盘解决方案。",
      storyOverline: "我们的故事",
      storyTitle: "实用的托盘方案，本地化服务",
      storyText: "Pallet Works Logistic 为 Inland Empire 地区的仓库、制造商、分销商和本地企业提供可靠的托盘解决方案。我们专注于可靠服务、快速沟通和实用的托盘选择，帮助企业满足日常运营需求。",
      focusOverline: "我们的重点",
      focusTitle: "围绕您的运营而设计",
      focuses: [
        { title: "专注本地企业", desc: "总部位于 San Bernardino，专注于 Inland Empire 地区企业的需求。" },
        { title: "仓库与运输支持", desc: "托盘供应确保您的装卸平台、货架和出货运输顺畅运转。" },
        { title: "提供取货与配送", desc: "我们上门服务——覆盖整个地区的托盘取货和本地配送。" },
        { title: "回收与供应选择", desc: "新托盘、二手托盘和回收托盘选择，满足您的预算和用量需求。" },
      ],
    },
    contact: {
      overline: "联系我们",
      title: "获取托盘报价",
      intro: "告诉我们您的需求，我们将尽快回复价格和库存信息。",
      formTitle: "获取报价",
      formSub: "填写以下表格，我们的团队将快速回复您。",
      success: "感谢——您的报价请求已收到。如有紧急需求，请致电",
      fields: {
        name: "姓名 *",
        company: "公司名称",
        phone: "电话号码 *",
        email: "电子邮件 *",
        service: "所需托盘类型或服务 *",
        quantity: "所需数量",
        fulfillment: "取货或配送 *",
        message: "留言",
      },
      placeholders: {
        name: "您的姓名",
        company: "您的公司",
        phone: "(909) 555-0123",
        email: "you@company.com",
        quantity: "例如 100",
        message: "请告诉我们尺寸、时间安排或其他需要了解的信息。",
        selectService: "请选择托盘类型或服务",
        selectFulfillment: "请选择",
      },
      pickup: "取货",
      delivery: "配送",
      other: "其他",
      submit: "发送报价请求",
      sending: "发送中...",
      toastSuccess: "报价请求已发送，我们将尽快回复您。",
      toastError: "出现问题，请致电 (909) 955-7500。",
      hoursLabel: "营业时间",
    },
    hours: [
      { days: "周一至周五", time: "6:00 AM – 8:00 PM" },
      { days: "周六", time: "需预约" },
      { days: "周日", time: "休息" },
    ],
    services: {
      "new-pallets": {
        title: "新托盘",
        short: "按照您的尺寸、规格和载重要求全新制造的木托盘。",
        long: "采用优质木材制造的新木托盘，满足您日常运输、存储和仓库运营需求。标准尺寸如 48x40 GMA，或按您的确切规格定制。",
      },
      "used-pallets": {
        title: "二手托盘",
        short: "经过检查和分级的二手托盘——日常运输的经济之选。",
        long: "优质二手托盘，在转售前经过检查、维修和分级。是单程运输、存储和一般仓库使用的实用经济选择。",
      },
      "custom-pallets": {
        title: "定制托盘",
        short: "为超大、超重或特殊货物定制的托盘尺寸和设计。",
        long: "当标准尺寸无法满足需求时，我们根据您的产品尺寸、重量和搬运设备定制托盘和垫板——从超大机械底座到特种垫板。",
      },
      "euro-pallets": {
        title: "欧标托盘",
        short: "标准 1200 x 800 欧标块式托盘，适用于国内和国际货运。",
        long: "标准 1200 x 800 毫米欧标块式托盘，四向进叉设计，兼容欧洲及国际供应链。",
      },
      "plastic-pallets": {
        title: "塑料托盘",
        short: "耐用、可清洗的塑料托盘，适用于食品、医药和闭环运营。",
        long: "重型塑料托盘，防潮、防碎屑、防污染。是食品加工、医药和闭环配送计划的理想选择。",
      },
      "corrugated-pallets": {
        title: "瓦楞托盘",
        short: "轻便、可回收的瓦楞托盘，适用于单程运输和空运。",
        long: "轻便的瓦楞托盘可降低货运重量和成本。完全可回收，是单程运输、出口纸箱和空运的明智选择。",
      },
      "pallet-recycling": {
        title: "托盘回收",
        short: "我们上门回收、维修和循环处理闲置托盘，保持您的场地整洁。",
        long: "保持您的装卸平台和场地整洁。我们回收闲置、破损或多余的托盘，维修可重复使用的部分，并负责任地回收其余部分。",
      },
      "pickup-delivery": {
        title: "托盘取货与配送",
        short: "按您的时间安排在整个 Inland Empire 地区提供取货和配送。",
        long: "我们回收多余托盘，并将订单直接配送到您在 San Bernardino 和 Inland Empire 的装卸平台。灵活的排期满足定期或一次性需求。",
      },
      "heat-treated-pallets": {
        title: "热处理托盘",
        short: "符合 ISPM-15 标准的热处理托盘，适用于出口和受监管货物。",
        long: "符合 ISPM-15 出口要求的热处理木托盘。经过规范处理并加施标识，确保您的国际货物顺利通过检验。",
      },
    },
    servicesCardOverrides: {
      "used-pallets": {
        title: "食品级托盘",
        long: "适用于食品相关存储、搬运和配送需求的清洁托盘选择。根据库存情况提供包括 48x40 在内的标准尺寸。",
      },
      "custom-pallets": {
        title: "B 级托盘",
      },
      "euro-pallets": {
        title: "普通托盘",
      },
      "corrugated-pallets": {
        title: "二手托盘堆",
      },
      "heat-treated-pallets": {
        title: "热处理托盘堆",
      },
      "pallet-recycling": {
        title: "仓库托盘供应",
        long: "为仓库、分销商和本地企业提供托盘供应解决方案。我们以可靠的托盘选择支持日常运输、存储和搬运运营。",
      },
      "new-pallets": {
        title: "托盘供应与配送",
        long: "为需要大批量托盘的企业提供可靠的托盘供应和配送服务。我们以可靠的本地服务支持仓库、运输、存储和日常运营。",
      },
    },
    products: {
      "new-pallets": { name: "新托盘", desc: "标准和定制尺寸的全新木托盘，满足日常运营需求。" },
      "used-pallets": { name: "二手托盘", desc: "经过检查和分级的二手托盘——以更低成本获得可靠品质。" },
      "custom-pallets": { name: "定制托盘", desc: "按您的尺寸、载重和搬运要求定制。" },
      "euro-pallets": { name: "欧标托盘", desc: "1200 x 800 块式托盘，适用于国际和国内供应链。" },
      "plastic-pallets": { name: "塑料托盘", desc: "防潮、可清洗的托盘，适用于卫生和闭环运营。" },
      "corrugated-pallets": { name: "瓦楞托盘", desc: "轻便、完全可回收的托盘，适用于单程运输和空运。" },
      "cp1-cp3-pallets": { name: "CP1 和 CP3 托盘", desc: "化工行业标准的 CP 托盘，适用于袋装和桶装货物。" },
      "heat-treated-pallets": { name: "热处理托盘", desc: "符合 ISPM-15 标准、加施标识，适用于出口和受监管货物。" },
    },
    footer: {
      quickLinks: "快速链接",
      services: "服务",
      contactInfo: "联系信息",
      description: "为 Inland Empire 地区的仓库、制造商、分销商和本地企业提供可靠的托盘解决方案。",
      rights: "版权所有。",
      location: "San Bernardino, CA — Inland Empire",
    },
  },
};
